import { useTranslation } from 'react-i18next';

import { FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';
import { EmptyState, PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';
import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

import { session } from '@/shared/session/session';

import { ChatProfileCard } from '../components/chat-profile-card';

function MyChatProfile() {
  const { t } = useTranslation('chatSettings');
  const { me } = session.useSession();
  const { can } = usePermissions();
  if (!me) return null;
  const readOnly = !can('conversations.write');
  const firstName = me.user.name.split(' ')[0] ?? me.user.name;

  return (
    <PageContent width="narrow">
      <PageHeader title={t('profile.title')} description={t('profile.description')} />
      {me.stores.length === 0 ? (
        <EmptyState title={t('profile.noStores')} />
      ) : (
        <div className="flex flex-col gap-6">
          {me.stores.map((store) => (
            <ChatProfileCard
              key={store.id}
              storeId={store.id}
              storeName={store.name}
              firstName={firstName}
              readOnly={readOnly}
            />
          ))}
        </div>
      )}
    </PageContent>
  );
}

/** `/account/chat-profile`: the signed-in member's chat name and avatar, per store. */
export function MyChatProfilePage() {
  return (
    <FeatureErrorBoundary name="chatSettings.profile">
      <MyChatProfile />
    </FeatureErrorBoundary>
  );
}
